import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { OpenItem, DisplayOrder } from "../../models";
import { OpenItemQuery } from "../../services";
import { UnsafeAction } from "../../actions/UnsafeAction";

/* tslint:disable */
@Injectable()
export class OpenItemsActions {

	static OPEN_ITEMS_SEARCH = "[OPEN ITEM] open items query"
	public openItemsSearch(query: OpenItemQuery): UnsafeAction {
		return {
			type: OpenItemsActions.OPEN_ITEMS_SEARCH,
			payload: query
		}
	}
	static OPEN_ITEMS_SEARCH_SUCCESS = "[OPEN ITEM] open items query success"
	public openItemsSearchSuccess(openItems): UnsafeAction{
		return {
			type: OpenItemsActions.OPEN_ITEMS_SEARCH_SUCCESS,
			payload: openItems
		}
	}

	static LOAD_OPEN_ITEM_BY_ID = "[OPEN ITEM] Load open item by id"
	public loadOpenItemById(id: string): UnsafeAction {
		return {
			type: OpenItemsActions.LOAD_OPEN_ITEM_BY_ID,
			payload: id
		}
	}

	static OPEN_ITEM_LOADED = "[OPEN ITEM] open item loaded"
	public openItemLoaded(openItem: OpenItem): UnsafeAction {
		return {
			type: OpenItemsActions.OPEN_ITEM_LOADED,
			payload: openItem
		}
	}


}



// WEBPACK FOOTER //
// ./src/app/components/open-items/open-items.actions.ts